import Vue from 'vue';

const state = {
  user_id: 0,
}

const mutations = {
  // 'BUY_STOCK'(state, {stockId, quantity, stockPrice}) {
  //   const record = state.stocks.find(element => element.id == stockId);
  //   if (record) {
  //     record.quantity += quantity;
  //   } else {
  //     state.stocks.push({
  //       id: stockId,
  //       quantity: quantity,
  //     });
  //   }
  //   state.funds -= stockPrice * quantity;
  // },
  // 'SELL_STOCK'(state, {stockId, quantity, stockPrice}) {
  //   const record = state.stocks.find(element => element.id == stockId);
  //   if (record.quantity > quantity) {
  //     record.quantity -= quantity;
  //   } else {
  //     state.stocks.splice(state.stocks.indexOf(record), 1);
  //   }
  //   state.funds += stockPrice * quantity;
  // },
  // 'SET_PORTFOLIO'(state, portfolio) {
  //   state.funds = portfolio.funds;
  //   state.stocks = portfolio.stockPortfolio ? portfolio.stockPortfolio : []; // Set it to the portfolio if it exists, otherwise empty array
  // },
  'LOGMEIN'(state, email) {
    console.log(email);
    let api_url = 'api/users/';
    // Vue.http.get('stockdata.json')
    // .then(response => response.json())
    // .then(data => {
    //   if (data) {
    //     const stocks = data.stocks;
    //     const funds = data.funds;
    //     const stockPortfolio = data.stockPortfolio;

    //     const portfolio = {
    //       stockPortfolio,
    //       funds
    //     };

    //     commit('SET_STOCKS', stocks);
    //     commit('SET_PORTFOLIO', portfolio);
    //   }
    // });
  },
};

const actions = {
  logMeIn: ({commit}, email) => {
    console.log('Got here');
    commit('LOGMEIN', email);
  },
  // sellStock({commit}, order) {
  //   commit('SELL_STOCK', order);
  // }
};

// const actions = {
//   buyStock: ({commit}, order) => {
//     commit('BUY_STOCK', order);
//   },
//   initStocks: ({commit}) => {
//     commit('SET_STOCKS', stocks);
//   },
//   randomizeStocks: ({commit}) => {
//     commit('RND_STOCKS');
//   }
// };

const getters = {
  user_id (state) {
    return state.user_id;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js